import React, { useState } from "react";
import MTextArea from "@/components/ui/atoms/MTextArea";

const TestTextArea: React.FC = () => {
  const [value, setValue] = useState("");

  return (
    <div style={{ padding: 32 }}>
      <h2>MTextArea Demo</h2>
      <div style={{ marginBottom: 24 }}>
        <label style={{ display: "block", marginBottom: 4 }}>Normal</label>
        <MTextArea
          placeholder="Type your message here..."
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
      <div style={{ marginBottom: 24 }}>
        <label style={{ display: "block", marginBottom: 4, color: "#C33F58" }}>
          Error
        </label>
        <MTextArea
          placeholder="Type your message here..."
          value={value}
          error
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
      <div style={{ marginBottom: 24 }}>
        <label style={{ display: "block", marginBottom: 4, color: "#217B57" }}>
          Success
        </label>
        <MTextArea
          placeholder="Type your message here..."
          value={value}
          success
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
      <div style={{ marginBottom: 24 }}>
        <label style={{ display: "block", marginBottom: 4, color: "#797979" }}>
          Disabled
        </label>
        <MTextArea
          placeholder="Type your message here..."
          value={value}
          disabled
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
      <div style={{ marginTop: 16 }}>
        <strong>Current value:</strong>
        <pre>{value}</pre>
      </div>
    </div>
  );
};

export default TestTextArea;
